<template>
  <div v-show="isVisible" class="cabinet-notification">
    <template v-if="userProjectIsInactive">
      <notification color-overlay="#ff5172">
        <p>
          <span data-blocked-title>{{ $t('project.blocked') }}</span>
          &nbsp;{{ $t('payments.intake.and.payouts.unavailable') }}
          <span data-blocked-link v-html="$t('contact.to.support', { projectName: PROJECT_INFO.name })"></span>
        </p>
      </notification>
    </template>

    <template v-else-if="isNeedIdentification">
      <template v-if="isAwaitingModification">
        <notification color-overlay="#ff5172">
          <p v-html="$t('clarification.identification.data')"></p>
          <a slot="button" class="button thin clear" target="_blank" @click="goToIdentity">
            <span>{{ $t('fill.form') }}</span>
          </a>
        </notification>
      </template>
      <template v-else>
        <notification>
          <p v-html="$t('raise.limits.and.remove.restrictions')"></p>
          <a slot="button" class="button thin clear" target="_blank" @click="goToIdentity">
            <span>{{ $t('fill.form') }}</span>
          </a>
        </notification>
      </template>
    </template>

    <template v-else-if="isShowSelfEmployedBindingNotification">
      <notification color-overlay="#9B51E0" image-overlay="self-employed">
        <p>{{ $t('confirm.self.employed.status') }}</p>
        <router-link slot="button" :to="{ name: 'selfEmployed' }" class="button thin clear">
          <span>{{ $t('turn.on.self.employed') }}</span>
        </router-link>
      </notification>
    </template>

    <template v-else-if="projectPaymentsDisabled">
      <notification>
        <p>
          <strong v-text="$t('notification.payment.disabled.title')" />
          &nbsp;{{ $t('notification.payment.disabled.message') }}
        </p>
        <a slot="button" href="https://help.capusta.space/contact_us" class="button thin clear" target="_blank">
          <span>{{ $t('notification.payment.disabled.submit') }}</span>
        </a>
      </notification>
    </template>

    <template v-else-if="!projectValidated">
      <notification>
        <p>
          <strong v-text="$t('notification.project.moderation.title')" />
          &nbsp;{{ displayLimitAmountMessage }}
        </p>
        <a slot="button" href="https://help.capusta.space/control" class="button thin clear" target="_blank">
          <span>{{ $t('notification.project.moderation.submit') }}</span>
        </a>
      </notification>
    </template>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import { formatAmount } from 'lib/utils/amount';

import Notification from 'modules/Notification/Notification';

import { IDENTITY } from '@/router/const';

export default {
  name: 'CabinetNotification',
  components: {
    Notification,
  },
  computed: {
    isVisible() {
      return this.userProjectIsInactive || this.isShowSelfEmployedBindingNotification || this.projectPaymentsDisabled || this.isNeedIdentification || !this.projectValidated;
    },
    displayLimitAmountMessage() {
      return this.$t('notification.project.moderation.message', {
        amount: formatAmount(this.getMaxAmount, this.PROJECT_INFO.currency),
      });
    },
    ...mapState(['PROJECT_INFO']),
    ...mapGetters([
      'userProjectIsInactive',
      'payoutPermissionIsEnabled',
      'projectPaymentsDisabled',
      'isNeedIdentification',
      'isShowSelfEmployedBindingNotification',
      'projectValidated',
    ]),
    ...mapGetters('identity', [
      'isAwaitingModification',
    ]),
    ...mapGetters('cards', [
      'isEmptyCardList',
    ]),
    ...mapGetters('bills', [
      'getMaxAmount',
    ]),
  },
  methods: {
    handleBindingCard() {
      if (this.isEmptyCardList) {
        this.$router.push({ name: 'card.binding' });
        return;
      }

      this.$router.push({ name: 'cardSelect' });
    },
    goToIdentity() {
      this.$router.push({ name: IDENTITY });
    },
  },
};
</script>

<style lang="sass" scoped>
  .cabinet-notification
    +respond-to('small')
      padding: 0 20px

    *
      &:not(:last-child)
        margin-bottom: 1px

        +respond-to('small')
          margin-bottom: 20px

    p
      strong
        font-weight: 600

      span[data-blocked-title]
        display: block

        +respond-to('medium')
          display: inline

      span[data-blocked-link]
        display: inline

        +respond-to('medium')
          display: block

      &::v-deep
        a
          text-decoration: underline
</style>
